import { Injectable, PLATFORM_ID, Inject,  ElementRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs';
import { AirportsService } from '../airports/airports.service';
import { CountriesService } from '../countries/countries.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class LangService {


  private currentLanguageSubscriber = this.translate.currentLang;
  private onLangChange: Subscription = undefined;
  private currentLanguage = new BehaviorSubject<any>(this.currentLanguageSubscriber);
  cl = this.currentLanguage.asObservable();

  constructor(@Inject(PLATFORM_ID) private platform: Object,
              private translate: TranslateService,
              private route: ActivatedRoute,
              private titleService: Title, private metaService: Meta,
              private airports: AirportsService,
              private countries: CountriesService,
              private config: ConfigService) {
                this.currentLanguage.subscribe( res => {
                  this.currentLanguageSubscriber = res;
                });
                this.onLangChange = this.translate.onLangChange.subscribe(() => {
                  this.updateLanguageMeta(this.translate.currentLang);
                  this.updateCurrentLanguage(this.translate.currentLang);
                  this.updateConfigs(this.translate.currentLang);
                  if (isPlatformBrowser(this.platform)) {
                    moment.locale(this.translate.currentLang);
                  }
                });
              }


  public initLang() {
    this.translate.addLangs(['en', 'de']);
    this.translate.setDefaultLang('en');
    let browserLang: string;
    let langCode: string;
    browserLang = this.translate.getBrowserLang();
    if (isPlatformBrowser(this.platform)) {
      this.route.queryParams.subscribe( params => {
        const userSelectedLang = localStorage.getItem('userDefaultLang');
        langCode = params.language_code;
        if (this.getCurrentLang() && !langCode && !userSelectedLang) {
          return;
        }
        if (langCode) {
          this.translate.use(langCode && langCode.match(/en|de/) ? langCode : 'en');
        } else if (userSelectedLang) {
          this.translate.use(userSelectedLang && userSelectedLang.match(/en|de/) ? userSelectedLang : 'en');
        } else {
          this.translate.use(browserLang.match(/en|de/) ? browserLang : 'en');
        }
      });
    } else if (isPlatformServer(this.platform)) {
      this.route.queryParams.subscribe( params => {
        langCode = params.language_code;
        if (this.getCurrentLang() && !langCode) {
          return;
        }
        //this.translate.use(langCode && langCode.match(/en|de/) ? langCode : 'en');
      });
    }
  }

  getCurrentLang() {
    return this.translate.currentLang;
  }

  updateCurrentLanguage(lang) {
    this.currentLanguage.next(lang);
  }

  updateLanguageMeta(lang) {
    this.metaService.updateTag({ name: 'language', content: lang }, `name='language'`);
    if (lang === 'en') {
      this.metaService.updateTag({ property: 'og:locale', content: 'en_GB' }, `property='og:locale'`);
    } else if (lang === 'de') {
      this.metaService.updateTag({ property: 'og:locale', content: 'de' }, `property='og:locale'`);
    } else {
      this.metaService.updateTag({ property: 'og:locale', content: 'en_GB' }, `property='og:locale'`);
    }
  }

  updateConfigs(lang) {
    const countryCode = this.config.getUserDefaultCountry() ? this.config.getUserDefaultCountry().country_code : null;
    this.countries.getCountries(null, lang).subscribe(res => {}, err => {});
    this.airports.getAirports(countryCode, null, null, null, lang).subscribe(res => {}, err => {});
  }
}
